module.exports = __webpack_public_path__ + "img/phone.c8fc9f96.jpg";